import { FC, useMemo } from 'react';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';

import { isPastDate, formatDate, dateFormatForUI } from 'utils/date';

interface Props {
  date: string;
  clashCount?: number;
  onClick?: () => void;
}

const Header: FC<Props> = ({ date, clashCount = 0, onClick }) => {
  const hasClashes = clashCount > 0;
  const classes = classNames('calendar__date_header', {
    'calendar__date_header--clashes': !!hasClashes,
  });

  const isBeforeEndOfDay = useMemo(() => isPastDate(date), [date]);

  return (
    <div className={classes}>
      <span>{formatDate(date, dateFormatForUI)}</span>
      <span className="calendar__date_header--right">
        {hasClashes && (
          <div className="clashes">
            <i className="fas fa-exclamation-triangle space__icon" />
            {I18n.t('advanced_booking.clash', { count: clashCount })}
          </div>
        )}
        {isBeforeEndOfDay && (
          <span>{I18n.t('advanced_booking.past_booking')}</span>
        )}
        {!isBeforeEndOfDay && !!onClick && (
          <button className="button button--small" onClick={onClick}>
            {I18n.t('delete')}
          </button>
        )}
      </span>
    </div>
  );
};

export default Header;
